<template>
  <div class="order-sale-detail">
    <nav-bar />
    <search-bar />
    <!-- 主内容区域：loading 初始为 true 且从未置为 false，故此处保持 v-if="loading" 使内容始终可见 -->
    <div class="main fz14 " v-if="loading">
      <div class="nav fr ac jsb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>我的订单</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div @click="applyDetailShow = true">
          <el-tag
            size="mini"
            v-show="returnOrderApplyState === 0"
            type="primary"
            >申请中</el-tag
          >
          <el-tag
            size="mini"
            v-show="returnOrderApplyState === 1"
            type="success"
            >已通过</el-tag
          >
        </div>
      </div>
      <div class="info-box">
        <div class="info mb20">
          <div class="fr ac fz12 mt20">
            <div class="center order-list-item">产品信息</div>
            <div class="center order-list-item">产品规格</div>
            <div class="center order-list-item">设备信息</div>
            <div class="center order-list-item">配套工艺</div>
            <div class="center order-list-item">产品价格</div>
            <div class="center order-list-item">数量</div>
            <div class="center order-list-item">商品价格</div>
            <div class="center order-list-item">操作</div>
          </div>
          <el-divider />
          <div class="order-list fz12">
            <div class="order-item mt20">
              <!--                上-->
              <div class="top">
                <div>
                  <span>{{ order_detail.create_time }}</span>
                  <span class="ml20 grey"
                    >订单编号：{{ order_detail.order_no }}</span
                  >
                  <span
                    class="ml40"
                    v-html="order_state_decide(order_detail)"
                  ></span>
                  <span class="ml40">{{ order_detail.company_name }}</span>
                </div>
              </div>
              <!--                中-->

              <div class="fr middle">
                <!-- 商品信息 -->
                <div class="order" style="width: 1158px">
                  <div
                    class="fr jc ac order-left"
                    v-for="(goods, i) in orderGoodsBeans"
                    :key="i"
                  >
                    <div class="fr pl10 pt20 pb20 order-list-item">
                      <el-image
                        class="goods_img fs mr10"
                        :src="goods.goods_img"
                        alt
                      />
                      <div class="fc jsb">
                        <p>
                          {{ goods.goods_name }} {{ goods.goods_standard_name }}
                        </p>
                        <p
                          class="red"
                          v-if="
                            !is_Empty(priceApplyInfo[goods.specification_id])
                          "
                        >
                          {{
                            orderSalePriceApplication(
                              priceApplyInfo[goods.specification_id],
                            )
                          }}
                        </p>
                      </div>
                    </div>

                    <div class="center order-list-item">
                      {{ specNameInit(goods) }}
                    </div>
                    <div class="center order-list-item">
                      {{ goods.device_id ? goods.device_id : "-" }}
                    </div>

                    <div class="center cursor order-list-item blue">
                      <el-popover placement="right" width="400" trigger="hover">
                        <el-table stripe :data="goods.orderCraftBeans || []">
                          <el-table-column
                            property="craft_name"
                            label="工艺名称"
                            align="center"
                          ></el-table-column>
                          <el-table-column
                            property="craft_count"
                            width="90"
                            label="工艺数量"
                            align="center"
                          ></el-table-column>
                        </el-table>
                        <div v-show="goods.drawings">
                          <p class="before-title">图纸信息</p>
                          <img-view :img="goods.drawings" />
                        </div>
                        <el-button
                          type="text"
                          slot="reference"
                          :disabled="orderDisabled"
                          @click="onShowSelectCraft(goods, i)"
                        >
                          工艺信息
                        </el-button>
                      </el-popover>
                    </div>

                    <div class="fc ac jc order-list-item">
                      <p>￥{{ goods.specification_price }}</p>
                      <p
                        class="blue p10"
                        v-if="findLastGoodsPrice(goods.specification_id)"
                      >
                        历史单价:￥{{
                          findLastGoodsPrice(goods.specification_id)
                        }}
                      </p>
                    </div>
                    <div class="center order-list-item">
                      {{ goods.goods_num }}
                    </div>
                    <div class="center order-list-item red">
                      ￥{{ goods.goods_actual_price }}
                    </div>
                    <div class="center order-list-item">
                      <el-button
                        :disabled="orderDisabled"
                        size="small"
                        type="text"
                        @click="
                          changePrice(
                            goods,
                            i,
                            priceApplyInfo[goods.specification_id],
                          )
                        "
                        >改价
                      </el-button>
                      <el-button
                        :disabled="orderDisabled"
                        size="small"
                        type="text"
                        @click="setMaterialInformation(goods, i)"
                        >设置信息
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>

              <!--                下-->
            </div>
          </div>
        </div>

        <p class="fz16 bold mt20 mb20">订单信息</p>
        <el-form
          label-width="130px"
          size="small"
          label-position="left"
          :disabled="orderDisabled"
        >
          <el-row>
            <el-col :span="12" class="pr10">
              <el-form-item label="当时客户是否存在反馈单" label-width="180px">
                <el-tag type="success" v-show="!isExistenceFeedback"
                  >不存在</el-tag
                >
                <el-tag type="warning" v-show="isExistenceFeedback"
                  >存在</el-tag
                >
              </el-form-item>
              <el-form-item label="合同类型">
                <el-select
                  v-model="submit_form.contract_type"
                  :disabled="orderDisabled"
                  placeholder="请选择合同类型"
                >
                  <el-option label="平台合同" :value="1"></el-option>
                  <el-option label="客户合同" :value="2"></el-option>
                </el-select>
                <el-button
                  v-if="submit_form.contract_type == '1'"
                  @click="paramsInit(0)"
                  >生成合同
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="is_sale_free"
                  >是否免单(免单额度:{{ free_price }})
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="is_foreign_trade"
                  >是否为外贸订单
                </el-checkbox>
              </el-form-item>
              <el-form-item label="服务费">
                <el-input
                  v-model="submit_form.order_service_price"
                  type="number"
                />
              </el-form-item>
              <el-form-item label="服务内容">
                <el-input
                  v-model="submit_form.order_service_remark"
                  type="textarea"
                  :rows="4"
                  resize="none"
                />
              </el-form-item>
              <el-form-item label="销售回款率">
                <span class="blue bold"
                  >{{ platform_sale_receivable_ratio }}%</span
                >
              </el-form-item>
              <el-form-item label="订单总价">
                <span class="red bold">￥{{ order_actual_price }}</span>
              </el-form-item>

              <el-form-item label-width="0">
                <span class="black">实际订单</span>
                <input
                  class="service-input"
                  :disabled="orderDisabled"
                  @input="deliveryTimeChange"
                  v-model.number="submit_form.delivery_time"
                  type="text"
                />
                <span>天交货</span></el-form-item
              >

              <el-form-item label-width="0">
                <span class="black">合同生效</span>
                <input
                  class="service-input"
                  :disabled="orderDisabled"
                  v-model.number="submit_form.contract_delivery_time"
                  type="text"
                />
                <span>天交货</span></el-form-item
              >
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同备注：">
                <el-input
                  v-model="submit_form.contract_remarks"
                  type="textarea"
                  resize="none"
                  show-word-limit
                  maxlength="40"
                />
              </el-form-item>
              <el-form-item label="其他条款：">
                <el-autocomplete
                  resize="none"
                  style="width: 100%;"
                  type="textarea"
                  :rows="4"
                  v-model="submit_form.contract_terms"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item
                label="地址备注："
                v-if="!is_Empty(orderAddressBean)"
              >
                <el-input
                  resize="none"
                  style="width: 100%;"
                  type="textarea"
                  :rows="4"
                  v-model="orderAddressBean.remarks"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item>
              <el-form-item label="订单备注：">
                <el-input
                  v-model="submit_form.order_remark"
                  type="textarea"
                  :rows="4"
                  resize="none"
                />
              </el-form-item>
              <el-form-item label="客户内部订单号：">
                <el-input
                  v-model="submit_form.vip_order_no"
                  style="width:100%"
                />
              </el-form-item>
              <el-form-item label="客户内部备注图片：">
                <up-load
                  :disabled="orderDisabled"
                  :file_list.sync="submit_form.vip_order_imgs"
                  :limit="6"
                />
              </el-form-item>
              <el-form-item
                label="驳回原因："
                v-show="order_detail.platform_sale_check_state === '-1'"
              >
                <el-input
                  v-model="order_detail.platform_sale_check_remarks"
                  size="small"
                  type="textarea"
                  :rows="6"
                  resize="none"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item
                label="驳回原因："
                v-show="order_detail.contract_check_state === '-1'"
              >
                <el-input
                  v-model="order_detail.contract_check_remarks"
                  size="small"
                  type="textarea"
                  :rows="6"
                  resize="none"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item
                label="驳回原因："
                v-show="order_detail.return_to_platform_sale_check_remarks"
              >
                <el-input
                  v-model="order_detail.return_to_platform_sale_check_remarks"
                  size="small"
                  type="textarea"
                  :rows="6"
                  resize="none"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 付款比例 -->
        <el-descriptions
          class="mt20"
          title="付款方式"
          direction="vertical"
          :column="3"
          border
          labelClassName="label-text"
          contentClassName="content-text"
        >
          <el-descriptions-item label="款到下单(元)">
            <input
              :disabled="orderDisabled"
              v-model="submit_form.pay_start_price"
              type="number"
              class="service-input"
            />
          </el-descriptions-item>
          <el-descriptions-item label="款到发货(元)">
            <input
              :disabled="orderDisabled"
              v-model="submit_form.pay_ing_price"
              type="number"
              class="service-input"
          /></el-descriptions-item>
          <el-descriptions-item label="货到付款(元)">
            <span>{{ pay_end_price }}元</span></el-descriptions-item
          >
        </el-descriptions>
        <el-form class="mt20" v-show="pay_end_price">
          <el-form-item label="货到">
            <el-input-number
              v-model.number="submit_form.pay_day"
              :min="1"
              size="mini"
            />
            天付款
            <span v-if="maxPayDay !== Infinity"
              >（最大{{ maxPayDay }}天，超出需申请！）</span
            >
            <el-tooltip placement="top">
              <div slot="content">
                货到后须多少天内付款
                <br />例：30天，货到后须在30天内将剩余的60%付齐。
                <br />货到付款最大天数为上次该客户申请的货到付款天数，<br />如后续订单的付款天数大于当前申请通过天数，需重新申请。
              </div>
              <i class="el-icon-warning-outline red"></i>
            </el-tooltip>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="12">
            <!-- 收货地址 -->
            <p class="fz16 bold mt20 mb20">收货地址</p>
            <div class="receipt mb20" v-if="!is_Empty(orderAddressBean)">
              <div class="top fr ac jsb">
                <div class="fr ac">
                  <p>{{ orderAddressBean.address_name }}</p>
                  <p class="ml20">
                    {{ this.formatPhone(orderAddressBean.address_mobile) }}
                  </p>
                </div>
                <div class="fr ac">
                  <el-button
                    :disabled="orderDisabled"
                    type="text"
                    @click="selectShow = true"
                    >更改地址
                  </el-button>
                </div>
              </div>
              <div class="bottom">
                {{ orderAddressBean.address_province }}
                {{ orderAddressBean.address_city }}
                {{ orderAddressBean.address_country }}
                {{ orderAddressBean.address_detailed }}
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <!-- 发票信息 -->
            <p class="fz16 bold mt20 mb20">发票信息</p>
            <el-form
              label-width="120px"
              size="small"
              label-position="left"
              :disabled="orderDisabled"
            >
              <el-form-item label="是否需要发票">
                <el-checkbox
                  :disabled="orderDisabled"
                  v-model="submit_form.is_invoice"
                  >是</el-checkbox
                >
              </el-form-item>
              <el-form-item label="开票抬头">
                <div class="fr ac" v-if="submit_form.is_invoice">
                  <span>{{
                    !is_Empty(orderInvoiceBean)
                      ? orderInvoiceBean.invoice_name
                      : "请填写发票"
                  }}</span>
                  <el-button
                    type="text"
                    class="ml10"
                    :disabled="orderDisabled"
                    @click="add_invoice_show = true"
                    >添加发票
                  </el-button>
                  <el-button
                    type="text"
                    class="ml10"
                    :disabled="orderDisabled"
                    @click="selectInvoiceShow = true"
                    >更改发票
                  </el-button>
                </div>
              </el-form-item>
              <el-form-item label="是否等通知开票">
                <el-switch v-model="submit_form.is_required_invoice_notify" />
              </el-form-item>
              <el-form-item label="开票备注：" v-show="submit_form.is_invoice">
                <el-input
                  v-model="submit_form.invoice_remark"
                  type="textarea"
                  size="mini"
                />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <p class="fz16 bold mt20">
              平台合同：
              <el-button
                size="mini"
                type="success"
                v-if="submit_form.contract_type == '1'"
                @click="stampOrder"
                >加盖骑缝章
              </el-button>
            </p>
            <up-load
              :file_list.sync="submit_form.contract_platform_imgs"
              :limit="6"
            />
          </el-col>
          <el-col :span="12">
            <p class="fz16 bold mt20">客户合同：</p>
            <up-load :file_list.sync="submit_form.contract_imgs" :limit="6" />
          </el-col>
        </el-row>
        <div
          class="mt20 fr ac jc"
          v-if="order_detail.contract_check_state !== '1'"
        >
          <div>
            <el-button type="primary" @click="paramsInit(1)"
              >确认订单</el-button
            >
          </div>

          <div class="ml50">
            <el-button type="warning" @click="platformSaleUpdateOrder(1)"
              >暂存订单</el-button
            >
          </div>
          <div class="ml50">
            <el-button type @click="rejectShow = true">驳回订单 </el-button>
          </div>
        </div>
      </div>
    </div>
    <footer-bar />

    <!-- 选择配套工艺 -->
    <select-craft
      v-if="!is_Empty(order_detail)"
      :show.sync="crafts_show"
      :select_craft_list.sync="goods_crafts"
      :craft_remark.sync="craft_remark"
      :goods_id="current_goods_id"
      :length="current_goods_length"
      :width="current_goods_width"
      @success="saveCraftChange"
    />

    <select-address
      :company_id="order_detail.company_id || ''"
      :address_id="Number(orderAddressBean.address_id)"
      :addressvisible.sync="selectShow"
      @selectAddress="selectAddress"
    />

    <!-- 添加发票 -->
    <add-invoice
      :company_id="order_detail.company_id"
      :invoiceVisible.sync="add_invoice_show"
      @cloneVisible="cloneVisible"
    />
    <!--    选择发票弹窗-->
    <select-invoice
      :company_id="order_detail.company_id || ''"
      :invoice_id="Number(orderInvoiceBean.invoice_id || '')"
      :invoiceVisible.sync="selectInvoiceShow"
      @selectInvoice="selectInvoice"
    />
    <price-apply
      :show.sync="priceShow"
      :order_id="order_detail.order_id"
      :goods="current_price"
      :company_id="order_detail.company_id"
      :contract_template="submit_form.contract_template"
      @success="priceChangeSuccess"
    />
    <reject-order
      v-model="rejectShow"
      :order_id="order_detail.order_id"
      :currentMessage="order_detail.return_to_platform_sale_check_remarks"
      @success="getOrderDetail"
    />
    <other-info
      :company_id="order_detail.company_id"
      v-model="setMaterialInformationShow"
      :goods="current_goods"
      @success="setMaterialInfo"
    />

    <apply-detail
      v-model="applyDetailShow"
      :apply-info="{
        isApplyGoods,
        isApplyRedYellowLine,
        isCashOnDeliveryApplication,
        isApplyContractClause,
        isApplyFeedback,
      }"
      :max-day="maxPayDay"
      :order-info="spliceData()"
      :order-feedback-info="orderFeedbackInfo"
      :company-info="companyInfo"
      @apply="applyForPermission"
      :platform_sale_receivable_ratio="platform_sale_receivable_ratio"
    />
    <!--    <el-backtop target="#app" :bottom="100">123</el-backtop>-->
  </div>
</template>

<script>
import { calculatePrice } from "./request";
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import Upload from "@/components/UploadImg";

import priceApply from "./component/priceApply";
//修改地址
import SelectAddress from "@/components/SelectAddress";
//修改地址
import AddInvoice from "@/components/AddInvoice";
import applyDetail from "./component/applyDetail";
//设置物料信息
import otherInfo from "./component/otherInfo";
//修改发票
import SelectInvoice from "@/components/SelectInvoice";

import RejectOrder from "./component/rejectOrder";

// scoreLevel 已在项目中声明但未在本组件使用，移除以减少无用引入
//订单预审模板type
const ORDERCHECK = "order_check";
export default {
  data() {
    return {
      historyContractClause: [],
      submitType: 0,
      originalContractTerms: "",
      orderAddressBean: {},
      orderInvoiceBean: {},
      orderGoodsBeans: [],
      lastGoodsPriceList: [],
      current_goods_length: "",
      current_goods_width: "",
      current_goods: {},
      param: {},
      selectInvoiceShow: false,
      setMaterialInformationShow: false,
      applyDetailShow: false,
      rejectShow: false,
      selectShow: false,

      submit_form: {
        contract_template: "",
        contract_terms: "",
        order_service_price: 0, //服务费,
        order_service_remark: "", //服务内容,
        delivery_time: "", //交付时间,
        pay_start_price: "0", //付款比例,,
        pay_ing_price: "0", //付款比例,
        is_invoice: false, //是否需要发票
        contract_type: "", //合同类型
        invoice_remark: "", //发票备注信息
        order_remark: "", //订单备注信息
        contract_remarks: "含税价", //订单备注信息
        vip_order_no: "", //内部订单备注
        vip_order_imgs: [], //内部订单备注
        contract_platform_imgs: [], // 平台合同
        contract_imgs: [], // 客户合同
        is_foreign_trade: 0, // 是否为外贸订单(与 data 中 is_foreign_trade 布尔字段互补,此处为接口字段)
      },
      current_goods_index: null,
      priceShow: false,
      current_price: {},
      platform_sale_receivable_ratio: null,
      actual_price: "",
      craft_remark: "",
      //工艺弹窗
      crafts_show: false,
      //地址弹窗
      add_invoice_show: false,

      //当前选择的商品id
      current_order_goods_id: "",
      //当前选择的商品id
      current_goods_id: "",
      is_skip_check: "0",
      goods_crafts: [],
      order_detail: {},
      orderApplyInfo: {},
      loading: true,
      payDeliveryRecord: {},
      orderFeedbackInfo: [],

      free_price: "",
      sealimg: "",
      is_sale_free: false,
      is_foreign_trade: false,
      materialsNoRequired: false,
      max_delivery_day: 0,
      feedbackOrderPlacementApprovalCode: "feedback_insert_order_check", //反馈单下单审批模板type
      redAndYellowLineOrderReviewCode: "red_yellow_order_check", //红黄线订单审核模板type
      contractClauseReviewCode: "contract_clause_check", //合同条款审批模板type
      companyInfo: {},
      priceApplyInfo: {},
    };
  },
  mounted() {
    this.getOrderDetail();
    this.getPlatformSaleFreeOrderPrice();
  },

  computed: {
    //-1驳回 0：申请中 1：已通过 2：无需申请
    returnOrderApplyState() {
      if (this.is_Empty(this.orderApplyInfo)) return -1;
      let { check_state } = this.orderApplyInfo;
      return check_state;
    },
    // 是否需要申请售价特批
    isApplyGoods() {
      if (this.is_Empty(this.orderGoodsBeans)) return 2;
      let isApply = !this.is_Empty(
        this.orderGoodsBeans.filter(
          (el) => Number(el.is_apply_goods_price) === 1,
        ),
      );
      if (!isApply) return 2;
      return this.checkOrderApplyState("apply_goods");
    },
    //如果该客户标记了免审核，则不需要申请任何审批
    isSkipCheck() {
      return this.is_skip_check === "1";
    },
    //-1驳回 0：申请中 1：已通过 2：无需申请
    //是否需要申请红黄线发货
    isApplyRedYellowLine() {
      if (this.isSkipCheck) return 2;
      if (this.is_Empty(this.companyInfo)) return 2;
      let { red_debt_value, yellow_debt_value } = this.companyInfo;
      if (Number(red_debt_value) + Number(yellow_debt_value) === 0) return 2;
      return this.returnOrderApplyState;
    },
    //  是否需要货到付款申请
    isCashOnDeliveryApplication() {
      if (this.isSkipCheck) return 2;
      if (this.pay_end_price === 0) return 2;
      if (this.is_sale_free) return 2;
      return this.checkOrderApplyState("pay_day");
    },
    //是否需要申请合同条款
    // 条件更改，以后每次的合同条款都需要申请。
    isApplyContractClause() {
      if (this.isSkipCheck) return 2;
      let { contract_terms } = this.submit_form;

      if (this.is_Empty(contract_terms)) return 2;
      return this.checkOrderApplyState("contract_terms");
    },
    //是否需要申请反馈单下单
    isApplyFeedback() {
      if (this.isSkipCheck) return 2;
      if (this.orderFeedbackInfo.length < 1) return 2;
      //如果订单类型不为1(普通订单)则不需要申请
      if (this.order_detail.order_type !== 1) return 2;
      return this.returnOrderApplyState;
    },
    //是否当前客户是否存在反馈单
    isExistenceFeedback() {
      return !this.is_Empty(this.orderFeedbackInfo);
    },

    // 是否可以继续修改订单信息
    orderDisabled() {
      return !this.is_Empty(this.submit_form.contract_platform_imgs);
    },
    pay_end_price() {
      if (this.is_Empty(this.order_detail) || this.is_Empty(this.submit_form)) {
        return 0;
      }
      let price = this.sub(
        this.order_actual_price,
        this.add(
          this.submit_form.pay_start_price,
          this.submit_form.pay_ing_price,
        ),
      );
      if (price < 0) {
        this.$message("输入价格不正确");
        this.submit_form.pay_start_price = 0;
        this.submit_form.pay_ing_price = 0;
      }
      return this.sub(
        this.order_actual_price,
        this.add(
          this.submit_form.pay_start_price,
          this.submit_form.pay_ing_price,
        ),
      );
    },
    order_actual_price() {
      if (this.is_Empty(this.order_detail) || this.is_Empty(this.submit_form)) {
        return 0;
      }
      let price = 0;
      this.orderGoodsBeans.forEach((el) => {
        price = this.add(price, el.goods_actual_price);
      });
      return this.add(price, this.submit_form.order_service_price);
    },

    //货到付款申请最大天数。
    maxPayDay() {
      try {
        if (!this.is_Empty(this.payDeliveryRecord)) {
          let { delivery_pay_day } = this.payDeliveryRecord;
          return Number(delivery_pay_day);
        }
        return Infinity;
      } catch (e) {
        console.log(e);
        return Infinity;
      }
    },
  },

  methods: {
    checkOrderApplyState(checkType = null) {
      let that = this;
      if (this.is_Empty(checkType)) return -1;
      let { component_values = "", check_state = 2 } = this.orderApplyInfo;
      component_values = this.isJSON(component_values)
        ? JSON.parse(component_values)
        : {};
      let { orderGoodsBeans, contract_terms, pay_day } = this.spliceData();

      function checkGoods() {
        let { check_types = "" } = component_values;
        let goodsList = component_values.goods_list || "[]";
        goodsList = JSON.parse(goodsList);
        if (check_state === 0) return 0;
        if (check_state === 1 && check_types.indexOf("价格审批") !== -1) {
          let isApply = orderGoodsBeans.some((el) => {
            let good = goodsList.find(
              (e) => el.order_goods_id === e.order_goods_id,
            );
            // 申请记录可能缺少已被删除的商品，缺少匹配项时不能阻断整单。
            if (!good) return false;
            // 统一转数字，兼容接口返回字符串 1 和数字 1。
            return (
              Number(good.goods_actual_price) > Number(el.goods_actual_price) &&
              Number(el.is_apply_goods_price) === 1
            );
          });
          return isApply ? -1 : 1;
        }
        let isApply = orderGoodsBeans.some(
          (el) => Number(el.is_apply_goods_price) === 1,
        );
        // console.log(`isApply:${isApply},${isApply ? -1 : 1}，orderGoodsBeans:${JSON.stringify(orderGoodsBeans)}`)
        return isApply ? -1 : 1;
      }

      function checkPayDay() {
        if (check_state === 0) return 0;
        return Number(pay_day) <= that.maxPayDay ? 1 : -1;
      }

      function checkTerms() {
        let { contract_terms: apply_terms = "" } = component_values || {};
        let isItConsistent =
          JSON.parse(contract_terms)[0].content === apply_terms;
        // 如果申请记录为空，则返回判断。
        if (that.is_Empty(component_values)) {
          return isItConsistent ? 1 : -1;
        }
        // 如果状态为申请中，直接返回
        if (check_state === 0) return 0;
        // 如果状态为已通过，则返回判断。
        return check_state === 1 ? (isItConsistent ? 1 : -1) : -1;
      }

      switch (checkType) {
        case "apply_goods":
          return checkGoods();
        case "pay_day":
          return checkPayDay();
        case "contract_terms":
          return checkTerms();
        default:
          return this.returnOrderApplyState;
      }
    },
    // 注意图片的，onload是异步的，如果要封装成工具函数，需要用promise包装一下
    imgToBase64(url) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = url;
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.naturalWidth; // 使用 naturalWidth 为了保证图片的清晰度
          canvas.height = image.naturalHeight;
          canvas.style.width = `${canvas.width / window.devicePixelRatio}px`;
          canvas.style.height = `${canvas.height / window.devicePixelRatio}px`;
          const ctx = canvas.getContext("2d");
          if (!ctx) {
            return null;
          }
          ctx.drawImage(image, 0, 0);
          const base64 = canvas.toDataURL("image/png");
          return resolve(base64);
        };
        image.onerror = (err) => {
          return reject(err);
        };
      });
    },
    async stampOrder() {
      let { contract_template, contract_platform_imgs } = this.spliceData();
      contract_platform_imgs = contract_platform_imgs.split(",");
      if (this.is_Empty(contract_platform_imgs)) {
        this.$message("未生成合同！");
        return;
      }
      if (contract_platform_imgs.length > 1) {
        this.$message("当前为多份合同！");
        return;
      }
      // let img = require(`./imgs/yifa_seal.png`)
      let img =
        contract_template === "yifa"
          ? require(`./imgs/yifa_seal.png`)
          : require(`./imgs/zjky.png`);
      let sealImg = await this.imgToBase64(img);

      let params = {
        original_pdf: contract_platform_imgs.join(","),
        sealStr: sealImg.replace("data:image/png;base64,", ""), // 图片
        seals: null,
        paging: {
          y: 1124 / 2 - 160,
        },
      };
      this.jsonPost("orderInterfaces/v1.0/stamp", params).then((res) => {
        this.$message.success("已加盖骑缝章！");
        this.submit_form.contract_platform_imgs = [res.data];
      });
    },
    async applyForPermission(type) {
      if (this.returnOrderApplyState === 0) {
        return this.$message("申请中，请勿重复提交");
      }
      let {
        order_id,
        order_no,
        company_name,
        company_sell_name,
        pay_start_price,
        pay_ing_price,
        pay_end_price,
        contract_template,
        pay_day,
        contract_terms,
        orderGoodsBeans,
      } = this.spliceData();
      let {
        red_debt_value,
        yellow_debt_value,
        auto_credit_score,
      } = this.companyInfo;
      let goods_list = orderGoodsBeans.map((el) => {
        return {
          goods_num: el.goods_num,
          order_goods_id: el.order_goods_id,
          specification_id: el.specification_id,
          specification_unit: el.specification_unit,
          specification_price: el.specification_price,
          standard_price: el.standard_price,
          goods_actual_price: el.goods_actual_price,
          standard_total_price: el.standard_total_price,
          goods_standard_name: el.goods_standard_name,
          fall_percent: el.fall_percent,
          goods_craft: el.orderCraftBeans
            .map(
              (el) => `工艺名称：${el.craft_name}、工艺数量：${el.craft_count}`,
            )
            .join("\n"),
          goods_specification: this.specNameInit(
            el,
            "orderGoodsSpecificationInputBeans",
          ),
        };
      });

      function parseContractTerms(str) {
        try {
          const data = JSON.parse(str);
          if (
            Array.isArray(data) &&
            data.length > 0 &&
            typeof data[0].content !== "undefined"
          ) {
            return data[0].content;
          }
          return "";
        } catch (e) {
          console.error("Failed to parse contract_terms:", e);
          return "";
        }
      }

      let obj = {
        order_id,
        order_no,
        company_name,
        contract_template:
          contract_template === "zjky" ? "浙江合同" : "益发合同",
        goods_list: JSON.stringify(goods_list),
        platform_sale_name: company_sell_name,
        pay_start_price,
        pay_ing_price,
        pay_end_price,
        pay_day,
        contract_terms: parseContractTerms(contract_terms),
        red_price: red_debt_value,
        yellow_price: yellow_debt_value,
        company_credit: auto_credit_score,
        feedback_desc: this.orderFeedbackInfo
          .map(
            (el) =>
              `反馈单订单编号：${el.order_no}\n商品名称：${el.goods_name} ${el.goods_standard_name}\n`,
          )
          .join("\n"),
      };

      obj.check_types = [];
      const CHECKKEYS = {
        isApplyRedYellowLine: "红黄线审批",
        isCashOnDeliveryApplication: "货到付款审批",
        isApplyContractClause: "合同条款审批",
        isApplyFeedback: "反馈单下单审批",
        isApplyGoods: "价格审批",
      };
      for (const key in CHECKKEYS) {
        if (this[key] === -1) {
          obj.check_types.push(CHECKKEYS[key]);
        }
      }
      obj.check_types = obj.check_types.join(",");
      this.post("/admin/dingtalkWorkflowRecord/applyOrderCheck", obj).then(
        (res) => {
          this.applyDetailShow = false;
          this.$message("申请已提交请等待审核通过");
          this.getLastRecordByRelationIdAndType();
        },
      );
    },
    //获取此客户此商品未完成的反馈单
    async getProcessingCompanyOrderFeedback(company_id, orderGoods) {
      let goods_id = [];
      orderGoods.forEach((el) => {
        goods_id.push(el.goods_id);
      });
      goods_id = this.unique(goods_id);
      let res = await this.post(
        "feedbackController/v1.0/getProcessingCompanyOrderFeedback",
        {
          company_id,
        },
      );
      this.orderFeedbackInfo = res.data;
    },

    deliveryTimeChange(e) {
      this.submit_form.contract_delivery_time = this.submit_form.delivery_time;
    },

    //获取客户额外配置信息,判断是否必须设置物料单号
    getCompanyExtra() {
      this.post("companyInterfaces/v1.0/getCompanyExtra", {
        company_id: this.order_detail.company_id,
      }).then((res) => {
        if (!this.is_Empty(res.data)) {
          let { materials_no_required, is_skip_check } = res.data;
          this.materialsNoRequired = materials_no_required === 1;
          this.is_skip_check = is_skip_check;
        }
      });
    },
    // 订单详情
    async getOrderDetail() {
      let orderInfo = await this.post("orderInterfaces/v1.0/getOrderDetail", {
        order_id: this.$route.query.order_id,
      });
      orderInfo = orderInfo.data;
      let s = await this.post("memberInterfaces/v1.0/getSellCompany", {
        company_id: orderInfo.company_id,
      });
      if (s) {
        let { is_delivery_pay, delivery_pay_day } = s.data;
        this.payDeliveryRecord = { is_delivery_pay, delivery_pay_day };

        this.companyInfo = s.data;
        //销售回款率
        let res = await this.post(
          "orderInterfaces/v1.0/getPlatformSaleReceivableRatio",
          {},
        );
        this.platform_sale_receivable_ratio = this.mul(res.data, 100);
      }
      let {
        contract_platform_imgs, //平台合同
        contract_imgs, //客户合同
        contract_template, //合同模板
        vip_order_imgs, //客户图片
        delivery_time, //交货时间
        contract_delivery_time, //交货时间
        is_sale_free, //是否免单
        pay_day, //货到后付款期限
        pay_start_price, //第一笔款
        pay_ing_price, //第二笔款
        pay_end_price, //第三笔款
        order_service_price, //服务费
        order_service_remark, //服务费内容
        order_actual_price, //订单实际金额
        contract_remarks, //合同备注信息
        contract_type, //合同类型
        order_remark, //订单备注信息
        vip_order_no, //内部订单备注
        order_machinery_manufacturers_discount_price, //厂商优惠价
        invoice_remark, //发票备注信息
        orderGoodsBeans, //商品信息
        orderAddressBean, //地址信息
        orderInvoiceBean, //发票信息
        contract_terms, //其他条款
        is_invoice, //是否需要发票
        version, //订单更改版本号
        is_required_invoice_notify, //是否需要等通知开票
        shop_id,
        is_foreign_trade,
      } = orderInfo;

      if (this.isJSON(contract_terms)) {
        contract_terms = JSON.parse(contract_terms)[0].content;
      }
      //获取订单详情后将合同条款初始信息赋值给一个字段，判断合同条款是否更新，是否需要申请。
      this.originalContractTerms = contract_terms;
      //如果是第一次进入详情页，并没有修改过订单信息需要倒推商品单价。
      if (version === 0 || version === 1) {
        let order_total_price = 0;
        orderGoodsBeans.forEach((el) => {
          let arr = [];
          el.orderGoodsSpecificationInputBeans.forEach((e) => {
            arr.push(e.input_value);
          });
          let count = 1;
          arr.forEach((el) => {
            count = this.mul(el, count);
          });
          let sum = this.mul(count, el.goods_num);
          el.goods_price = this.toDecimal2(
            this.div(el.goods_actual_price, sum),
          );
          el.specification_price = el.goods_price;
          order_total_price = this.add(
            order_total_price,
            el.goods_actual_price,
          );
        });

        order_actual_price = this.add(order_total_price, order_service_price);
        pay_start_price = 0;
        pay_ing_price = 0;
        pay_end_price = order_actual_price;
      }

      this.submit_form = {
        contract_platform_imgs: this.strToArr(contract_platform_imgs), //平台合同
        contract_imgs: this.strToArr(contract_imgs), //客户合同
        vip_order_imgs: this.strToArr(vip_order_imgs), //客户图片
        contract_template: !this.is_Empty(shop_id) ? "zjky" : "yifa", //合同模板
        delivery_time, //交货时间
        contract_delivery_time, //交货时间
        is_sale_free, //是否免单
        pay_day: pay_day, //货到后付款期限
        pay_start_price, //第一笔款
        pay_ing_price, //第二笔款
        pay_end_price, //第三笔款
        order_service_price, //服务费
        order_service_remark, //服务费内容
        order_actual_price, //订单实际金额
        contract_remarks: contract_remarks || "含税价", //合同备注信息
        contract_type: this.is_Empty(contract_type)
          ? null
          : Number(contract_type), //合同类型
        order_remark, //订单备注信息
        vip_order_no, //内部订单备注
        order_machinery_manufacturers_discount_price, //厂商优惠价
        invoice_remark, //发票备注信息
        orderGoodsBeans, //商品信息
        orderAddressBean, //地址信息
        orderInvoiceBean, //发票信息
        contract_terms, //其他条款
        is_invoice: is_invoice == "1", //是否需要发票
        is_foreign_trade, //是否为外贸订单
        is_required_invoice_notify: is_required_invoice_notify === 1, //是否需要等通知开票
      };
      this.is_sale_free = is_sale_free == "1";
      this.is_foreign_trade = is_foreign_trade == "1";
      this.orderAddressBean = orderAddressBean;
      this.orderInvoiceBean = orderInvoiceBean;
      this.orderGoodsBeans = orderGoodsBeans;
      this.order_detail = orderInfo;
      await this.getApplyInfo({ orderGoodsBeans });
    },
    // 通过传入的类型，获取对应的状态。
    async getLastRecordByRelationIdAndType(type) {
      let res = await this.post(
        "admin/dingtalkWorkflowRecord/getLastRecordByRelationIdAndType",
        {
          relation_id: this.$route.query.order_id,
          type: ORDERCHECK,
        },
      );
      this.orderApplyInfo = res.data;
    },
    //客户商品价格申请记录
    async getCompanyGoodsApplyRecord(specification_id) {
      let goodsApplyRecordRequest = {
        order_type: this.order_detail.order_type,
        company_id: this.order_detail.company_id,
      };
      let res = await this.post(
        "orderInterfaces/v1.0/getCompanyGoodsApplyRecord",
        {
          ...goodsApplyRecordRequest,
          specification_id,
        },
      );
      return res.data;
    },
    querySearch(queryString, cb) {
      // 调用 callback 返回建议列表的数据
      cb(this.historyContractClause);
    },
    findLastGoodsPrice(id) {
      let o = this.lastGoodsPriceList.find((el) => el.specification_id === id);
      return o ? o.specification_price : 0;
    },
    async getApplyInfo({ orderGoodsBeans }) {
      //获取商品改价申请信息
      let specification_ids = [],
        priceApplyInfo = {};
      orderGoodsBeans.forEach((el) => {
        specification_ids.push(el.specification_id);
      });
      specification_ids = this.unique(specification_ids);

      for (let i = 0; i < specification_ids.length; i++) {
        let el = specification_ids[i];
        let data = await this.getCompanyGoodsApplyRecord(el);
        if (!this.is_Empty(data)) priceApplyInfo[el] = data;
      }
      this.priceApplyInfo = priceApplyInfo;

      //获取客户是否存在红黄线金额，用以判断是否需要申请红黄线
      let { company_id } = this.companyInfo;
      // 获取商品历史价格。
      this.post("orderInterfaces/v1.0/getLastOrderGoodsPrice", {
        company_id,
        specification_ids: specification_ids.join(","),
      }).then((res) => {
        this.lastGoodsPriceList = res.data;
      });
      // 获取订单预审申请信息
      await this.getLastRecordByRelationIdAndType();
      //客户历史审核通过的合同条款
      this.post("orderInterfaces/v1.0/getHistoryCompanyContractClause", {
        company_id,
      }).then((res) => {
        try {
          let arr = [];
          res.data.forEach((el) => {
            if (this.isJSON(el)) {
              let e = JSON.parse(el);
              if (!this.is_Empty(e[0])) {
                arr.push({ value: e[0].content });
              }
            }
          });
          this.historyContractClause = arr;
        } catch (e) {
          console.log(e);
        }
      });
      //获取此客户此商品未完成的反馈单
      await this.getProcessingCompanyOrderFeedback(company_id, orderGoodsBeans);
      //获取客户额外配置信息,判断是否必须设置物料单号
      await this.getCompanyExtra();
      //详情接口返回的改价标记可能尚未按当前价格计算，加载后主动同步一次权限状态。
      await this.refreshGoodsPriceApplyState(orderGoodsBeans);
    },
    async priceChangeSuccess(goods) {
      this.orderGoodsBeans.splice(this.current_goods_index, 1, goods);

      let res = await this.platformSaleUpdateOrderGoods(goods);
      //发起改价申请后请求审批信息。
      let data = await this.getCompanyGoodsApplyRecord(goods.specification_id);
      if (!this.is_Empty(data)) {
        let priceApplyInfo = JSON.parse(JSON.stringify(this.priceApplyInfo));
        priceApplyInfo[goods.specification_id] = data;
        this.priceApplyInfo = priceApplyInfo;
      }
      //改价弹窗关闭后再次按当前价格校准，确保审批判断不依赖用户是否打开过弹窗。
      await this.refreshGoodsPriceApplyState(this.orderGoodsBeans);
    },
    /**
     * 根据当前商品实际金额同步改价审批标记。
     * @param {Array<Object>} orderGoodsBeans 订单商品列表
     * @returns {Promise<void>} 完成所有商品价格权限校验
     */
    async refreshGoodsPriceApplyState(orderGoodsBeans = []) {
      const goodsList = Array.isArray(orderGoodsBeans) ? orderGoodsBeans : [];
      if (!goodsList.length || this.is_Empty(this.order_detail.company_id)) {
        return;
      }

      // 相同规格只计算一次，避免重复请求并保持同规格商品的审批状态一致。
      const specificationIds = this.unique(
        goodsList
          .map((goods) => goods.specification_id)
          .filter((specificationId) => !this.is_Empty(specificationId)),
      );

      await Promise.all(
        specificationIds.map(async (specificationId) => {
          const goods = goodsList.find(
            (item) => item.specification_id === specificationId,
          );
          if (!goods) return;

          try {
            const res = await calculatePrice({
              ...goods,
              company_id: this.order_detail.company_id,
            });
            const calculatedGoods = res.data.orderGoodsBeans[0];
            const minimumPrice = Number(calculatedGoods.goods_min_price);
            const actualPrice = Number(goods.goods_actual_price);

            // 价格低于系统计算的最低价格才需要售价特批；无效结果保留接口原标记。
            if (!Number.isFinite(minimumPrice) || !Number.isFinite(actualPrice)) {
              return;
            }
            const isApply = actualPrice < minimumPrice ? 1 : 0;
            goodsList.forEach((item) => {
              if (item.specification_id === specificationId) {
                item.is_apply_goods_price = isApply;
              }
            });
          } catch (error) {
            // 价格权限接口失败时保留后端原始标记，不影响订单详情正常使用。
            console.warn("同步商品改价权限失败", error);
          }
        }),
      );
    },
    //修改商品信息
    async platformSaleUpdateOrderGoods(obj) {
      let {
        order_goods_id,
        craft_remark,
        goods_id,
        goods_num,
        goods_actual_price,
        goods_price,
        specification_price,
        specification_id,
        company_goods_no,
        goods_total_price,
        company_goods_name,
        orderGoodsSpecificationInputBeans,
        orderCraftBeans,
        is_apply_goods_price,
        fall_percent,
        standard_price,
        standard_total_price,
        company_requirement_json,
      } = obj;
      craft_remark = this.spliceCraftRemark({
        remark: craft_remark,
        requirement_json: company_requirement_json,
      });
      orderCraftBeans.forEach((el) => {
        if (typeof el.craft_extra === "object") {
          el.craft_extra = JSON.stringify(el.craft_extra);
        }
      });
      let o = {
        order_goods_id,
        craft_remark,
        goods_id,
        goods_num,
        fall_percent,
        is_apply_goods_price: is_apply_goods_price ? 1 : 0,
        standard_price,
        standard_total_price,
        goods_actual_price,
        goods_price,
        specification_price,
        goods_total_price,
        specification_id,
        company_requirement_json: company_requirement_json || "[]",
        company_goods_no,
        company_goods_name,
        orderGoodsSpecificationInputBeans,
        orderCraftBeans,
        order_id: this.$route.query.order_id,
      };
      return await this.jsonPost(
        "orderInterfaces/v1.0/platformSaleUpdateOrderGoods",
        o,
      );
    },
    //获取销售免单金额
    getPlatformSaleFreeOrderPrice() {
      this.post(
        "platformSaleInterfaces/v1.0//getPlatformSaleFreeOrderPrice",
        {},
      ).then((res) => {
        this.free_price = res.data;
      });
    },
    // 审批状态
    orderSalePriceApplication(goods) {
      if (this.is_Empty(goods)) {
        return "";
      }
      if (goods.check_state == "0") {
        return `改价审批中(待审单价:${goods.price})`;
      }
      if (goods.check_state == "1") {
        return `上次审批最低单价:${goods.price}`;
      }
      if (goods.check_state == "-1") {
        return "审批拒绝";
      }
      return "";
    },
    cloneVisible(info) {
      this.post("invoiceInterfaces/v1.0/getInvoiceDetail", {
        invoice_id: info.invoice_id,
        company_id: this.order_detail.company_id,
      }).then((res) => {
        this.orderInvoiceBean = res.data;
      });
    },
    selectAddress(row) {
      this.orderAddressBean = row;
    },
    selectInvoice(row) {
      this.orderInvoiceBean = row;
    },
    //    驳回订单
    rejectOrder(order_id) {
      let param = { order_id: order_id };
      this.post("orderInterfaces/v1.0/rejectOrder", param).then((res) => {
        this.$message("驳回成功");
        this.getOrderDetail();
      });
    },
    //保存工艺选择
    saveCraftChange() {
      let obj = {};
      this.orderGoodsBeans.forEach((item) => {
        if (this.current_order_goods_id == item.order_goods_id) {
          item.orderCraftBeans = JSON.parse(JSON.stringify(this.goods_crafts));
          obj = item;
        }
      });
      this.platformSaleUpdateOrderGoods(obj);
    },
    //显示商品工艺列表
    onShowSelectCraft(goods) {
      goods.orderGoodsSpecificationInputBeans.forEach((el) => {
        this[`current_${el.input_name}`] = Number(el.input_value);
      });
      this.current_order_goods_id = goods.order_goods_id;
      this.current_goods_id = goods.goods_id;
      this.goods_crafts = JSON.parse(JSON.stringify(goods.orderCraftBeans));
      this.craft_remark = goods.craft_remark;
      this.crafts_show = true;
    },
    //   改价弹窗
    async changePrice(row, index, applyInfo) {
      if (this.returnOrderApplyState === 0) {
        this.$message("改价审批中，请等待通过或驳回后操作！");
        return;
      }

      if (this.is_sale_free) {
        this.$message.warning("已免单,无法修改商品信息!");
        return;
      }
      let arr = [];
      this.orderGoodsBeans.forEach((el) => {
        if (el.order_goods_id !== row.order_goods_id) {
          arr.push(
            `${el.goods_standard_name} ${this.specNameInit(el)} 单价:￥${
              el.goods_price
            }/${el.price_unit} 数量:${el.goods_num}${
              el.specification_unit
            } 小计：${el.goods_actual_price}`,
          );
        }
      });
      row.other_order_goods_json = arr.join("\n");
      this.current_goods_index = index;

      this.current_price = Object.assign({}, row);

      this.actual_price = row.goods_actual_price;
      this.priceShow = true;
    },
    //显示设置物料信息弹窗
    setMaterialInformation(goods, index) {
      this.current_goods = Object.assign({}, goods);
      this.goods_index = index;
      this.setMaterialInformationShow = true;
    },
    async setMaterialInfo(e) {
      this.orderGoodsBeans.splice(this.goods_index, 1, e);
      let res = await this.platformSaleUpdateOrderGoods(e);
    },
    spliceCraftRemark({ remark, requirement_json }) {
      try {
        if (this.is_Empty(remark) && this.is_Empty(requirement_json)) return "";
        let str = [];
        if (!this.is_Empty(requirement_json)) {
          if (typeof requirement_json === "string")
            requirement_json = JSON.parse(requirement_json);
          requirement_json.forEach((el) => {
            str.push(el.content);
          });
        }
        if (!this.is_Empty(remark)) {
          let index = remark.indexOf("特殊要求");
          if (index === -1)
            return (
              remark + `${remark.length ? "  " : ""}特殊要求:${str.join("、")}`
            );
        }
        return (
          remark.substring(0, index) +
          `${remark.length ? "  " : ""}特殊要求:${str.join("、")}`
        );
      } catch (error) {
        console.log(error);
      }
    },
    //拼接用于请求的数据
    spliceData() {
      let submit_form = this.submit_form;
      let obj = {
        order_id: this.$route.query.order_id,
        company_id: this.order_detail.company_id,
        order_no: this.order_detail.order_no,
        company_sell_name: this.order_detail.company_sell_name,
        create_time: this.order_detail.create_time,
        company_name: this.order_detail.company_name,
        ...submit_form,
        orderAddressBean: this.orderAddressBean,
        orderInvoiceBean: this.is_Empty(this.orderInvoiceBean)
          ? null
          : this.orderInvoiceBean,
        is_sale_free: this.is_sale_free ? "1" : "0",
        is_foreign_trade: this.is_foreign_trade ? "1" : "0",
        is_required_invoice_notify: submit_form.is_required_invoice_notify
          ? 1
          : 0,
        is_invoice: !this.is_Empty(this.orderInvoiceBean) ? "1" : "0",
        order_total_price: this.order_actual_price,
        order_actual_price: this.order_actual_price,
        pay_end_price: this.pay_end_price,
        contract_imgs: this.arrToStr(submit_form.contract_imgs),
        vip_order_imgs: this.arrToStr(submit_form.vip_order_imgs),
        contract_platform_imgs: this.arrToStr(
          submit_form.contract_platform_imgs,
        ),
      };
      //如果是确认订单，并且勾选了免单，金额就需要传原始的金额。
      if (this.submitType === 0 && this.is_sale_free) {
        obj.pay_start_price = 0;
        obj.pay_ing_price = 0;
        obj.pay_end_price = 0;
        obj.order_service_price = 0;
        obj.order_total_price = 0;
        obj.order_actual_price = 0;
      }
      let contract_terms = [];
      contract_terms.push({ content: obj.contract_terms });
      obj.contract_terms = JSON.stringify(contract_terms);
      obj.orderGoodsBeans = [];
      this.orderGoodsBeans.forEach((el) => {
        let craft_remark = this.spliceCraftRemark({
          remark: el.craft_remark,
          requirement_json: el.company_requirement_json,
        });
        // el.company_requirement_json = company_requirement_json;
        if (!this.is_Empty(el.company_device_remarks)) {
          craft_remark += `   设备特殊要求：${el.company_device_remarks}`;
        }
        let o = {
          orderCraftBeans: el.orderCraftBeans,
          craft_remark,
          device_id: el.device_id,
          goods_id: el.goods_id,
          order_goods_id: el.order_goods_id,
          goods_num: el.goods_num,
          goods_actual_price: el.goods_actual_price,
          goods_price: el.goods_price,
          specification_price: el.goods_price,
          specification_id: el.specification_id,
          goods_type: el.goods_type,
          standard_price: el.goods_original_unit_price,
          standard_total_price: el.goods_total_price,
          orderGoodsSpecificationInputBeans:
            el.orderGoodsSpecificationInputBeans || [],
          goods_name: el.goods_name,
          goods_standard_name: el.goods_standard_name,
          specification_unit: el.specification_unit,
          price_unit: el.price_unit,
          company_goods_no: el.company_goods_no,
          company_goods_name: el.company_goods_name,
          specification_name: el.specification_name,
          is_apply_goods_price: el.is_apply_goods_price ? 1 : 0,
          fall_percent: el.fall_percent,
          company_requirement_json: el.company_requirement_json,
        };
        if (this.submitType === 0 && this.is_sale_free) {
          o.goods_actual_price = 0;
          o.goods_price = 0;
          o.specification_price = 0;
        }
        if (
          this.submitType === 0 &&
          ["小于", "大于"].some((e) => o.specification_name.indexOf(e) !== -1)
        ) {
          o.specification_name = "定制";
        }
        obj.orderGoodsBeans.push(o);
      });
      if (obj.pay_end_price === 0) obj.pay_day = 0;
      return obj;
    },
    //暂存订单数据
    platformSaleUpdateOrder(type) {
      let params = this.spliceData();
      delete params.orderGoodsBeans;

      this.jsonPost(
        "orderInterfaces/v1.0/platformSaleUpdateOrder",
        params,
      ).then((res) => {
        this.$message.success("已暂存数据！");
      });
    },
    async paramsInit(type) {
      let arr = [
        this.isApplyRedYellowLine,
        this.isCashOnDeliveryApplication,
        this.isApplyContractClause,
        this.isApplyFeedback,
        this.isApplyGoods,
      ];
      //判断数组中是否存在未通过/未申请的审批，如果未通过则无法进行下一步。
      if (arr.some((el) => [-1, 0].includes(el))) {
        this.applyDetailShow = true;
        return false;
      }
      let {
        is_foreign_trade,
        orderGoodsBeans,
        vip_order_no,
        contract_imgs,
      } = this.spliceData();

      let goodsBeans = orderGoodsBeans;
      let isNext = true;

      for (const priceApplyInfoKey in this.priceApplyInfo) {
        let { check_state, order_id } = this.priceApplyInfo[priceApplyInfoKey];
        if (check_state === "0" && order_id === this.order_detail.order_id) {
          this.$message("当前有订单商品处于改价申请中,无法生成合同!");
          return false;
        }
        if (check_state === "-1" && order_id === this.order_detail.order_id) {
          let current = goodsBeans.find(
            (el) => el.specification_id === priceApplyInfoKey,
          );
          let res = await calculatePrice({
            ...current,
            company_id: this.order_detail.company_id,
          });
          let { goods_min_price } = res.data.orderGoodsBeans[0];
          if (current.goods_actual_price < Number(goods_min_price)) {
            isNext = false;
          }
        }
      }
      if (!isNext) {
        this.$message("当前商品改价被驳回,请重新改价!");
        return false;
      }
      if (
        is_foreign_trade === "1" &&
        this.is_Empty(contract_imgs) &&
        type === 1
      ) {
        this.$message("当前为外贸订单，请上传PI合同和水单！");
        return;
      }
      if (
        is_foreign_trade === "1" &&
        this.is_Empty(vip_order_no) &&
        type === 1
      ) {
        this.$message("请将PI号填写到客户内部订单号！");
        return;
      }

      this.submitType = type;
      let submit_form = this.submit_form;

      if (!submit_form.delivery_time) {
        this.$message("请选择交付时间");
        return;
      }
      if (!submit_form.contract_type) {
        this.$message("请选择合同类型");
        return;
      }

      let total_price = goodsBeans.reduce(
        (pre, cur) => this.add(pre, cur.goods_actual_price),
        0,
      );
      total_price = this.add(total_price, submit_form.order_service_price);
      if (Number(total_price) !== Number(this.order_actual_price)) {
        this.$message("实付金额与商品金额不正确");
        return false;
      }

      let total_pay_price = this.add(
        submit_form.pay_start_price,
        this.add(submit_form.pay_ing_price, this.pay_end_price),
      );
      if (total_pay_price !== this.order_actual_price) {
        this.$message("付款比例不正确");
        return;
      }
      if (
        this.pay_end_price != 0 &&
        !Number(submit_form.pay_day) &&
        !this.is_sale_free
      ) {
        this.$message("请输入货到付款天数");
        return;
      }
      if (this.materialsNoRequired && this.is_Empty(submit_form.vip_order_no)) {
        this.$message("请输入客户订单号！");
        return;
      }
      let list = goodsBeans.filter(
        (el) =>
          Number(el.goods_price) !==
          this.findLastGoodsPrice(el.specification_id),
      );
      if (list.length) {
        let text = [];
        const h = this.$createElement;
        list.forEach((el) => {
          text.push(
            h(
              "p",
              null,
              `${this.specNameInit(el, "orderGoodsSpecificationInputBeans")}`,
            ),
          );
        });
        this.$msgbox({
          title: "温馨提示",
          message: h("div", null, [
            ...text,
            h("p", null, "以上商品的价格与历史价格不同，是否继续？"),
          ]),
          showCancelButton: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
        }).then((action) => {
          if (type === 0) {
            this.genPlatformContract();
          } else {
            this.sellConfirmOrder();
          }
        });
      } else {
        if (type === 0) {
          this.genPlatformContract();
        } else {
          this.sellConfirmOrder();
        }
      }
    },
    // 生成合同
    genPlatformContract() {
      /*
       * 如果是免单，销售可能未改价
       * 如果不更改商品信息会导致下次再进入详情界面时因为已经更改过商品信息，所以不会再重新倒推单价。
       * 再次进入的商品单价为商品原价
       * 所以在免单生成合同前保存一下倒推的商品价格。
       * */

      this.orderGoodsBeans.forEach((el) => {
        if (el.version === 1 || this.is_sale_free)
          this.platformSaleUpdateOrderGoods(el);
      });

      let param = this.spliceData();
      this.post("orderInterfaces/v1.0/genPlatformContract", {
        order_json: JSON.stringify(param),
      }).then((res) => {
        let contract_platform_imgs = [];
        if (this.submit_form.contract_platform_imgs.length) {
          contract_platform_imgs = this.submit_form.contract_platform_imgs;
        }
        contract_platform_imgs.push(res.data);
        this.submit_form.contract_platform_imgs = contract_platform_imgs;

        this.submitType = 1;
        this.platformSaleUpdateOrder();
        window.open(
          `https://wx.beltdance.com/pdf/web/viewer.html?file=${res.data}`,
        );
      });
    },
    //判断是否需要上传合同
    checkUploadContract(info) {
      let {
        pay_start_price,
        pay_ing_price,
        pay_end_price,
        contract_type,
        order_actual_price,
      } = info;
      pay_start_price = Number(pay_start_price);
      pay_ing_price = Number(pay_ing_price);
      pay_end_price = Number(pay_end_price);
      contract_type = Number(contract_type);
      order_actual_price = Number(order_actual_price);
      //订单金额为0时，不需要上传合同
      if (order_actual_price === 0) return false;
      //当第一笔钱是0并且是平台合同时需要上传双方合同。
      if (
        pay_start_price === 0 &&
        contract_type === 1 &&
        (this.is_Empty(info.contract_imgs) ||
          this.is_Empty(info.contract_platform_imgs))
      ) {
        this.$message("请上传合同");
        return true;
      }
      //如果第一笔钱是0并且是客户合同需要上传客户合同，不限制上传平台合同。
      if (
        pay_start_price === 0 &&
        contract_type === 2 &&
        this.is_Empty(info.contract_imgs)
      ) {
        this.$message("请上传客户盖章合同");
        return true;
      }
      return false;
    },
    //提交
    async sellConfirmOrder() {
      let param = this.spliceData();
      if (this.checkUploadContract(param)) return;
      param.address_json = JSON.stringify(param.orderAddressBean);
      param.invoice_json = "{}";
      if (param.is_invoice === "1") {
        param.invoice_json = JSON.stringify(param.orderInvoiceBean);
      }

      param.json = JSON.stringify(param.orderGoodsBeans);
      delete param.orderAddressBean;
      delete param.orderInvoiceBean;
      delete param.orderGoodsBeans;

      this.post("orderInterfaces/v1.0/sellConfirmOrder", param).then((res) => {
        this.$message("提交成功");
        this.back();
      });
    },

    // 获取默认发票
    getDefaultInvoice() {
      this.post("invoiceInterfaces/v1.0/getDefaultInvoice", {
        company_id: this.order_detail.company_id,
      }).then((res) => {
        this.orderInvoiceBean = res.data;
      });
    },
  },
  components: {
    RejectOrder,
    NavBar,
    SearchBar,
    FooterBar,
    "up-load": Upload,
    "add-invoice": AddInvoice,
    "select-address": SelectAddress,
    "select-invoice": SelectInvoice,
    priceApply,
    otherInfo,
    applyDetail,
  },
};
</script>

<style lang="scss">
// ============================================================
// confirm.vue 样式 — 订单详情页美化
// 主要改动：视觉层次、圆角阴影、渐变区块标题、更好的色彩对比
// 未改动布局结构和交互逻辑
// ============================================================

.order-sale-detail {
  min-height: 100vh;
  background: linear-gradient(180deg, #f6f8fc 0%, #edf2f7 100%);
  color: #1f2937;

  // 整页柔和背景
  body {
    background-color: #f5f7fa;
  }

  .main {
    width: 1200px;
    margin: 0 auto;
    padding: 24px 0 40px;

    // ---- 服务输入框（交货天数等） ----
    .service-input {
      width: 80px;
      background-color: transparent;
      border-bottom: 1px solid #409eff;
      text-align: center;
      color: #409eff;
      font-weight: 500;
      outline: none;
      transition: border-color 0.3s;
      &:focus {
        border-bottom-color: #66b1ff;
      }
    }

    // ---- 顶部导航/面包屑区域 ----
    .nav {
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      padding: 18px 24px;
      margin-bottom: 20px;
    }

    // ---- 主体内容卡片 ----
    .info-box {
      width: 100%;
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      padding: 24px;

      // ========== 区块标题（订单信息 / 收货地址 / 发票信息 等） ==========
      // 为所有作为小节的 <p> 标签（fz16 bold）加左竖条装饰
      > .fz16.bold {
        position: relative;
        padding-left: 14px;
        font-weight: 700;
        font-size: 15px;
        color: #303133;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 2px;
          bottom: 2px;
          width: 4px;
          border-radius: 2px;
          background: #409eff;
        }
      }

      // ========== 收货地址卡片 ==========
      .receipt {
        width: 400px;
        border: 1px solid #ebeef5;
        border-radius: 6px;
        overflow: hidden;
        transition: box-shadow 0.3s, border-color 0.3s;
        &:hover {
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.12);
          border-color: #d9ecff;
        }

        .top {
          padding: 16px 20px;
          border-bottom: 1px solid #ebeef5;
          background: #fafcff;
        }

        .bottom {
          padding: 16px 20px;
          line-height: 1.8;
          color: #606266;
        }
      }

      // ========== 商品列表区域 ==========
      .info {
        background-color: transparent;

        .order-list-item {
          &:nth-of-type(1) {
            width: 300px;
          }
          &:nth-of-type(2) {
            width: 130px;
          }
          &:nth-of-type(3) {
            width: 130px;
          }
          &:nth-of-type(4) {
            width: 130px;
          }
          &:nth-of-type(5) {
            width: 130px;
          }
          &:nth-of-type(6) {
            width: 100px;
          }
          &:nth-of-type(7) {
            width: 130px;
          }
          &:nth-of-type(8) {
            width: 130px;
          }
        }

        // 列表表头加深背景
        .fr.ac.fz12 {
          background: #f5f7fa;
          border-radius: 4px 4px 0 0;
          padding: 10px 0;
        }

        .order-list {
          .order-item {
            border: 1px solid #ebeef5;
            border-radius: 6px;
            overflow: hidden;

            .top {
              background: linear-gradient(135deg, #f0f6ff 0%, #e6f2ff 100%);
              padding: 14px 18px;
              border-bottom: 1px solid #ebeef5;
              font-size: 13px;
              color: #303133;
            }

            .middle {
              border-bottom: 1px solid #ebeef5;

              .order {
                .order-left {
                  border-right: 1px solid #ebeef5;
                  border-bottom: 1px solid #ebeef5;
                  position: relative;
                  padding: 12px;

                  &:last-child {
                    border-bottom: none;
                  }

                  .goods_img {
                    width: 80px;
                    height: 80px;
                    border-radius: 4px;
                    object-fit: cover;
                  }

                  .fc.jsb p {
                    margin: 0;
                    font-size: 13px;
                    color: #303133;
                    line-height: 1.5;
                  }
                }

                .apply-state {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 70px;
                  z-index: 2;
                }

                .operating {
                  p {
                    margin-top: 10px;
                    &:nth-of-type(1) {
                      margin-top: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }

      // ========== 表单项目美化 ==========
      .el-form-item {
        background-color: #f0f6ff;
        border-bottom: 1px solid #fff;
        margin-bottom: 0;
        padding: 10px 20px;
      }

      // ========== 价格框 ==========
      .price-box {
        font-size: 14px;
        .price-item {
          padding: 0 20px;
          min-height: 50px;
          background-color: #fafcff;
          border-bottom: 1px solid #ebeef5;
          .vip_order_imgs {
            width: 80px;
            height: 80px;
            margin-right: 10px;
          }
        }
        .contract_img {
          width: 150px;
          height: 150px;
          margin-right: 10px;
          border-radius: 4px;
        }
      }
    }

    .title {
      width: 200px;
    }
  }

  // ========== 付款方式描述表格 ==========
  .label-text {
    background-color: #f5f7fa;
    font-weight: 700;
    color: #303133;
    text-align: center !important;
    font-size: 14px;
  }

  .content-text {
    text-align: center !important;
  }

  // ========== 文本颜色增强 ==========
  .blue {
    color: #409eff !important;
  }
  .red {
    color: #f56c6c !important;
  }
  .grey {
    color: #909399 !important;
  }
  .black {
    color: #303133 !important;
  }
  .orange {
    color: #e6a23c !important;
  }
  .green {
    color: #67c23a !important;
  }

  // ========== 底部操作按钮区域 ==========
  .mt20.fr.ac.jc {
    padding: 16px 0;
    border-top: 1px dashed #ebeef5;
    margin-top: 24px;
    .el-button {
      border-radius: 4px;
      & + .ml50 {
        margin-left: 0;
      }
    }
    .ml50 {
      margin-left: 24px;
    }
  }

  // ========== 表格/Popover 微调 ==========
  .el-popover {
    .el-table {
      th {
        background: #f5f7fa;
        color: #303133;
      }
    }
    .before-title {
      font-size: 12px;
      color: #909399;
      margin-bottom: 8px;
      font-weight: 500;
    }
  }

  // ========== 页面升级覆写 ==========
  // 保留原有业务结构，仅增强容器、列表和表单的视觉层次。
  .main {
    width: calc(100% - 32px);
    max-width: 1320px;
    padding: 20px 0 56px;
  }

  .nav {
    position: sticky;
    top: 12px;
    z-index: 20;
    align-items: center;
    padding: 16px 20px;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid #e5eaf1;
    border-radius: 14px;
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.06);
    backdrop-filter: blur(10px);

    .el-breadcrumb {
      font-size: 14px;
      font-weight: 600;
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #1f2937;
    }

    .el-tag {
      height: 28px;
      padding: 0 10px;
      border: 0;
      border-radius: 999px;
      line-height: 26px;
      font-weight: 600;
    }
  }

  .info-box {
    margin-top: 16px;
    padding: 28px 28px 22px;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid #e5eaf1;
    border-radius: 18px;
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.05);
  }

  .info-box > .fz16.bold {
    margin-top: 28px;
  }

  .info-box > .fz16.bold:first-of-type {
    margin-top: 0;
  }

  .info-box > .fz16.bold::before {
    background: linear-gradient(180deg, #409eff 0%, #7db6ff 100%);
  }

  .info {
    overflow-x: auto;
    padding-bottom: 4px;

    .fr.ac.fz12 {
      padding: 12px 0;
      background: #f7f9fc;
      border: 1px solid #e8edf4;
      border-bottom: none;
      border-radius: 14px 14px 0 0;
      color: #5b6472;
      font-weight: 600;
    }

    .order {
      width: 100% !important;
      min-width: 1158px;
    }

    .order-list {
      overflow: hidden;
      border: 1px solid #e8edf4;
      border-top: none;
      border-radius: 0 0 14px 14px;

      .order-item {
        margin-top: 0;
        border: none;
        border-top: 1px solid #e8edf4;
        border-radius: 0;
        box-shadow: none;
        transition: background 0.2s ease, box-shadow 0.2s ease;

        &:first-child {
          border-top: none;
        }

        &:hover {
          background: #fbfdff;
          box-shadow: inset 0 0 0 999px rgba(64, 158, 255, 0.02);
        }

        .top {
          padding: 16px 20px;
          background: linear-gradient(135deg, #f6faff 0%, #edf5ff 100%);
          font-size: 13px;
          color: #334155;
        }

        .middle {
          background: #fff;

          .order {
            .order-left {
              padding: 16px 14px;
              align-items: stretch;
              background: #fff;
              transition: background 0.2s ease;

              &:hover {
                background: #fbfdff;
              }

              .goods_img {
                width: 88px;
                height: 88px;
                border: 1px solid #edf2f7;
                border-radius: 10px;
                object-fit: cover;
              }

              .fc.jsb p {
                margin: 0;
                line-height: 1.5;
                word-break: break-word;
              }
            }

            .order-list-item {
              min-height: 120px;
              padding: 14px 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              color: #475569;

              &:first-child {
                justify-content: flex-start;
                text-align: left;
              }
            }
          }
        }
      }
    }
  }

  .info-box .el-form-item {
    margin-bottom: 12px;
    padding: 12px 16px;
    background: linear-gradient(180deg, #fcfdff 0%, #f6f9fd 100%);
    border: 1px solid #e8edf4;
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.03);
  }

  .info-box .el-form-item__label {
    color: #475569;
    font-weight: 600;
  }

  .info-box .el-input__inner,
  .info-box .el-textarea__inner {
    border-color: #dbe3ee;
    border-radius: 10px;
    background: #fff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .info-box .el-input__inner:focus,
  .info-box .el-textarea__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
  }

  .receipt {
    width: min(420px, 100%);
    background: #fff;
    border: 1px solid #e5eaf1;
    border-radius: 14px;
    box-shadow: 0 10px 26px rgba(15, 23, 42, 0.05);

    .top {
      padding: 16px 20px;
      background: #f7faff;
      border-bottom: 1px solid #e5eaf1;
    }

    .bottom {
      padding: 16px 20px;
      line-height: 1.8;
      color: #475569;
    }
  }

  .label-text {
    background-color: #f7f9fc;
    font-weight: 700;
    color: #334155;
    text-align: center !important;
    font-size: 14px;
  }

  .content-text {
    text-align: center !important;
    background: #fff;
  }

  .el-descriptions {
    overflow: hidden;
    border: 1px solid #e8edf4;
    border-radius: 14px;
    background: #fff;
  }

  .el-descriptions__header {
    padding: 14px 18px;
    background: #f7f9fc;
    border-bottom: 1px solid #e8edf4;
  }

  .el-descriptions__title {
    color: #1f2937;
    font-size: 15px;
    font-weight: 700;
  }

  .price-box {
    overflow: hidden;
    border: 1px solid #e8edf4;
    border-radius: 14px;
    background: #fff;
  }

  .mt20.fr.ac.jc {
    position: sticky;
    bottom: 16px;
    z-index: 18;
    margin-top: 28px;
    padding: 18px 20px;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid #e8edf4;
    border-radius: 16px;
    box-shadow: 0 16px 32px rgba(15, 23, 42, 0.06);
    backdrop-filter: blur(10px);

    .el-button {
      min-width: 128px;
      border-radius: 10px;

      & + .ml50 {
        margin-left: 0;
      }
    }

    .ml50 {
      margin-left: 16px;
    }
  }

  .el-button--text {
    font-weight: 600;
  }

  // ========== 订单信息整体化 ==========
  // 商品区保持一体化表格观感，仅使用行分隔线区分内容，避免单元格卡片化。
  .nav,
  .info-box,
  .receipt,
  .el-descriptions,
  .price-box,
  .mt20.fr.ac.jc {
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.045);
  }

  .info .fr.ac.fz12 {
    border-radius: 6px 6px 0 0;
  }

  .info .order-list {
    border-radius: 0 0 6px 6px;
    box-shadow: none;
  }

  .info .order-list .order-item {
    border-radius: 0;
    box-shadow: none;
  }

  .info .order-list .order-item .top {
    border-radius: 0;
  }

  .info .order-list .order-item .middle .order .order-left {
    padding: 12px 14px;
    border-right: 0;
    border-bottom: 1px solid #eef2f7;
  }

  .info
    .order-list
    .order-item
    .middle
    .order
    .order-left:last-child {
    border-bottom: 0;
  }

  .info
    .order-list
    .order-item
    .middle
    .order
    .order-list-item {
    min-height: 96px;
    border-radius: 0;
  }

  .info
    .order-list
    .order-item
    .middle
    .order
    .order-left
    .goods_img {
    border-radius: 6px;
  }

  .info-box .el-form-item {
    border-radius: 6px;
    box-shadow: none;
  }

  .info-box .el-input__inner,
  .info-box .el-textarea__inner {
    border-radius: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/salesOrder/confirm.vue